﻿export const appConfig = {
  appName: "RLSys Business",
  shortName: "RLSys",
  fullMeaning: "Retail & Logistics System",

  version: "v1.0.0",

  clientName: "Entreprise Démo",
  displayName: "RLSys Business",

  slogan: "Gestion commerciale • Stock • POS • Logistique",

  description:
    "RLSys Business est une application de gestion commerciale et logistique adaptée aux entreprises de vente, distribution, stock, POS, agents commerciaux et livraison.",

  logo: "/rlsys.png",

  currency: "USD",
  localCurrency: "CDF",

  designerName: "Ruben Kanku",
  designerLabel: "Conçu et développé par Ruben Kanku",

  /*
    MODE D’UTILISATION

    - "single" : petite entreprise avec une seule structure principale.
    - "multi"  : entreprise avec plusieurs organisations, structures, shops,
                 agents, entrepôts et dashboards séparés.
  */
  dashboardMode: "multi",

  /*
    APPELLATIONS MÉTIER PARAMÉTRABLES

    Ces labels permettent d’adapter l’application à plusieurs types de clients :
    boutique, restaurant, pharmacie, quincaillerie, grossiste, PME,
    entreprise de distribution ou entreprise multi-sites.
  */
  businessLabels: {
    mainCompany: "Entreprise principale",
    mainCompanyShort: "Entreprise",

    centralOrganization: "Organisation centrale",
    centralOrganizations: "Organisations centrales",

    mainDistributor: "Distributeur principal",
    mainDistributors: "Distributeurs principaux",

    relayDepot: "Structure secondaire",
    relayDepots: "Structures secondaires",

    shop: "Shop",
    shops: "Shops",

    pointOfSale: "Point de vente",
    pointsOfSale: "Points de vente",

    fieldAgent: "Agent commercial",
    fieldAgents: "Agents commerciaux",

    warehouse: "Entrepôt",
    warehouses: "Entrepôts",

    driver: "Chauffeur",
    drivers: "Chauffeurs",

    vehicle: "Véhicule",
    vehicles: "Véhicules",

    delivery: "Livraison",
    deliveries: "Livraisons",

    customer: "Client",
    customers: "Clients",

    supplier: "Fournisseur",
    suppliers: "Fournisseurs",

    companyPrice: "Prix entreprise",
    distributorPrice: "Prix distributeur principal",
    relayPrice: "Prix structure secondaire",
    shopPrice: "Prix shop",

    supplierDebt: "Dette envers l’entreprise principale",
    customerDebt: "Créances clients",

    validationCompany: "Validation entreprise principale",
    validationDistributor: "Validation distributeur principal",
    validationRelay: "Validation structure secondaire",

    decisionCompany: "Décision entreprise principale",

    companyWarehouse: "Entrepôt entreprise",
    sourceWarehouse: "Entrepôt source entreprise",

    stockOrder: "Commande stock",
    stockOrders: "Commandes stock",

    cashDeposit: "Dépôt caisse",
    cashDeposits: "Dépôts caisse",

    reconciliation: "Rapprochement",
    reconciliations: "Rapprochements",
  },

  /*
    TYPES D’ORGANISATIONS

    Les valeurs techniques restent compatibles avec le backend.
    Les labels visibles sont génériques.
  */
  organizationTypes: {
    kin_mousse: "Organisation centrale",
    distributor: "Distributeur principal",
    relay_depot: "Structure secondaire",
    commercial_team: "Agents commerciaux",
    shop_group: "Réseau de shops",
  },

  /*
    TYPES DE SHOPS

    Les valeurs techniques restent compatibles avec le backend.
    Les labels visibles sont adaptés à RLSys Business.
  */
  storeTypes: {
    kin_mousse_shop: "Shop entreprise",
    maison_djo_shop: "Shop distributeur principal",
    relay_shop: "Shop structure secondaire",
    internal: "Point interne entreprise",
  },

  /*
    MODULES PARAMÉTRABLES

    Pour un petit client :
    - garder sales, stock, payments, reporting.
    - désactiver agents, logistics, warehouses si le client n’en a pas besoin.

    Pour une grande entreprise :
    - garder tous les modules actifs.
  */
  modules: {
    organizations: true,
    sales: true,
    payments: true,
    cashDeposits: true,
    expenses: true,
    debts: true,
    stock: true,
    warehouses: true,
    stockOrders: true,
    stockTransfers: true,
    stockAudits: true,
    logistics: true,
    vehicles: true,
    drivers: true,
    agents: true,
    productPrices: true,
    reporting: true,
    activityLogs: true,
    administration: true,
    sunmiPrinting: true,
  },

  /*
    DASHBOARDS PARAMÉTRABLES

    Pour un client simple :
    dashboardMode: "single"
    garder seulement le dashboard global.

    Pour un client multi-organisation :
    dashboardMode: "multi"
    activer les dashboards nécessaires.
  */
  dashboards: {
    global: {
      enabled: true,
      showInMenu: true,
      label: "Dashboard global",
      path: "/dashboard",
      description: "Vue générale de l’activité commerciale.",
    },

    distributor: {
      enabled: true,
      showInMenu: true,
      label: "Dashboard distributeur principal",
      path: "/maison-djo-dashboard",
      description:
        "Suivi du distributeur principal, ventes, stock, paiements et rentabilité.",
    },

    relay: {
      enabled: true,
      showInMenu: true,
      label: "Dashboard structure secondaire",
      path: "/depot-relais-dashboard",
      description:
        "Suivi des structures secondaires, ventes, dettes, stock, paiements et rentabilité.",
    },

    agents: {
      enabled: true,
      showInMenu: true,
      label: "Dashboard agents",
      path: "/agent-commercial-dashboard",
      description:
        "Suivi des agents commerciaux, demandes terrain, ventes et commissions.",
    },

    warehouses: {
      enabled: true,
      showInMenu: true,
      label: "Dashboard entrepôts",
      path: "/warehouse-dashboard",
      description: "Suivi des stocks par entrepôt, mouvements et alertes.",
    },

    logistics: {
      enabled: true,
      showInMenu: true,
      label: "Dashboard logistique",
      path: "/logistics-dashboard",
      description:
        "Suivi des livraisons, véhicules, chauffeurs, carburant, distances et coûts.",
    },

    pro: {
      enabled: true,
      showInMenu: true,
      label: "Dashboard PRO",
      path: "/dashboard-pro",
      description: "Vue analytique avancée pour la direction.",
    },

    reporting: {
      enabled: true,
      showInMenu: true,
      label: "Reporting",
      path: "/reporting",
      description: "Rapports, indicateurs et tableaux de bord.",
    },

    activityLogs: {
      enabled: true,
      showInMenu: true,
      label: "Journal d’activité",
      path: "/activity-logs",
      description: "Suivi des actions utilisateurs dans le système.",
    },
  },
}

/*
  HELPERS GÉNÉRIQUES

  Ces fonctions permettent aux pages d’utiliser les appellations configurées
  sans écrire directement les anciens noms d’un client dans le code.
*/

export const getBusinessLabel = (key, fallback = "") => {
  return appConfig.businessLabels?.[key] || fallback || key
}

export const getOrganizationTypeLabel = (key, fallback = "") => {
  return appConfig.organizationTypes?.[key] || fallback || key
}

export const getStoreTypeLabel = (key, fallback = "") => {
  return appConfig.storeTypes?.[key] || fallback || key
}

export const getModuleStatus = (key) => {
  return appConfig.modules?.[key] !== false
}

export const isModuleEnabled = (key) => {
  return getModuleStatus(key)
}

export const getDashboardConfig = (key) => {
  return appConfig.dashboards?.[key] || null
}

export const isDashboardEnabled = (key) => {
  const dashboard = getDashboardConfig(key)

  if (!dashboard) {
    return false
  }

  return dashboard.enabled !== false
}

export const isDashboardVisibleInMenu = (key) => {
  const dashboard = getDashboardConfig(key)

  if (!dashboard) {
    return false
  }

  return dashboard.enabled !== false && dashboard.showInMenu !== false
}

export const getEnabledDashboards = () => {
  return Object.entries(appConfig.dashboards || {})
    .filter(([key]) => isDashboardEnabled(key))
    .map(([key, dashboard]) => ({
      key,
      ...dashboard,
    }))
}

export const getVisibleDashboards = () => {
  return Object.entries(appConfig.dashboards || {})
    .filter(([key]) => isDashboardVisibleInMenu(key))
    .map(([key, dashboard]) => ({
      key,
      ...dashboard,
    }))
}

export const getAppTitle = () => {
  return appConfig.displayName || appConfig.appName || "RLSys Business"
}

export const getAppSubtitle = () => {
  return appConfig.fullMeaning || "Retail & Logistics System"
}

export const getAppVersionLabel = () => {
  return `${getAppTitle()} ${appConfig.version || "v1.0.0"}`
}